import Bold_Next_Arrow_Icon from '../icon/Bold_Next_Arrow_Icon';
import { Link } from 'react-router-dom';
import { PROFILE_LIST_INFO } from './constant';
import { GetCoachProfileWriteList } from '#api/accounts';

interface Props {
  getCoachProfileWriteList: GetCoachProfileWriteList | undefined;
}

const ProfileList = ({ getCoachProfileWriteList }: Props) => {
  return (
    <>
      {PROFILE_LIST_INFO.filter(
        info =>
          getCoachProfileWriteList?.[
            info.type as keyof GetCoachProfileWriteList
          ] === false
      ).map(list => {
        if (list.type === 'review') {
          return (
            <a
              key={list.type}
              href={list.routing}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col gap-12 p-16 rounded-8 bg-[#24222A] min-w-[216px]"
            >
              <list.icon />
              <div className="flex flex-col gap-10">
                <div className="flex items-center gap-4">
                  <h3 className="font-medium text-[#EAE8ED]">{list.title}</h3>
                  <Bold_Next_Arrow_Icon />
                </div>
                <span className="text-[14px] text-[#C9C7D1]">
                  {list.content}
                </span>
              </div>
            </a>
          );
        } else {
          // Internal link (uses <Link>)
          return (
            <Link
              key={list.type}
              to={list.routing}
              className="flex flex-col gap-12 p-16 rounded-8 bg-[#24222A] min-w-[216px]"
            >
              <list.icon />
              <div className="flex flex-col gap-10">
                <div className="flex items-center gap-4">
                  <h3 className="font-medium text-[#EAE8ED]">{list.title}</h3>
                  <Bold_Next_Arrow_Icon />
                </div>
                <span className="text-[14px] text-[#C9C7D1]">
                  {list.content}
                </span>
              </div>
            </Link>
          );
        }
      })}
    </>
  );
};

export default ProfileList;
